__turbopack_context__.v({
  "bubble": "loader-module-scss-module__KqE7lW__bubble",
  "loader": "loader-module-scss-module__KqE7lW__loader",
  "loader_item": "loader-module-scss-module__KqE7lW__loader_item",
  "loader_itemBubble": "loader-module-scss-module__KqE7lW__loader_itemBubble",
});
